import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import FieldGroupSection from "./FieldGroupSection";
import { useFieldValuesContext } from "./FieldValuesContext";
import { getFieldInputIdsPerGroup } from "./entityFieldNavigator";

const FieldList = () => {
  const { fieldGroups, objectType } = useFieldValuesContext();

  if (fieldGroups.length === 0) {
    return (
      <Typography color="textSecondary" sx={{ py: 1 }}>
        No fields available for this object type
      </Typography>
    );
  }

  const fieldInputIdsPerGroup = getFieldInputIdsPerGroup(objectType, fieldGroups);

  return (
    <Stack spacing={1}>
      {fieldGroups.map((group, index) => (
        <React.Fragment key={group.name}>
          {
            <FieldGroupSection
              group={group}
              fieldInputIds={fieldInputIdsPerGroup[index] ?? new Map<string, string>()}
            />
          }
          {index !== fieldGroups.length - 1 && (
            <Box sx={{ py: 2 }}>
              <Divider />
            </Box>
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default FieldList;
